import { Icon } from "components/common"
import { TitleDescription } from "components/custom"
import { t } from "i18next"
import { capitalizeFirstLetter, joinBytItems, localisedValue } from "utils"
import getPrivilege from "utils/privileges/privileges"
import { useRef } from "react"
import { ProjectModal } from "../../../shared/components"
const Interest = ({ data, privileges }) => {
  const projectRef = useRef()
  const onClickProject = e => () => {
    projectRef?.current?.showFor(e?.projectId)
  }
  const getInterestTitle = e =>
    e?.interestedIn == "secondary" ? (
      <div className="text-link pointer">{localisedValue({ key: "name", object: data?.type })}</div>
    ) : getPrivilege(["can_view_client_project_summary"], privileges) ? (
      <div className="text-link pointer" onClick={onClickProject(data?.project)}>
        {localisedValue({ key: "name", object: data?.project })}
      </div>
    ) : (
      localisedValue({ key: "name", object: data?.project })
    )

  const getInterestDesc = e => {
    const items =
      e?.interestedIn === "secondary"
        ? [localisedValue({ key: "name", object: data?.purpose }), "Secondary"]
        : [
            localisedValue({ key: "name", object: data?.type }),
            localisedValue({ key: "name", object: data?.purpose }),
            t(capitalizeFirstLetter(localisedValue({ key: "interestedIn", object: data }))),
          ]
    return joinBytItems(items, <Icon icon="GoDotFill" size=".7em" color="#D6D6D6" />)
  }

  return (
    <>
      <TitleDescription
        title={getInterestTitle(data)}
        gapSpace={4}
        description={getInterestDesc(data)}
        titleClassName="text-link"
        key={`interest - ${data.id}`}
      />
      <ProjectModal ref={projectRef} />
    </>
  )
}

export default Interest
